<template>
    <div class="navi">
        <template v-if="isDealer()">
            <router-link :to="{name:getLinkTarget('CODealerSettingHospital', 'CODealerSettingHospital'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                <div :class='getClass("CODealerSettingHospital")'><b-icon icon="hospital-building"/>施設管理</div>
            </router-link>
            <router-link :to="{name:getLinkTarget('CODealerSettingUser', 'CODealerSettingUser'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                <div :class='getClass("CODealerSettingUser")'><b-icon icon="account-multiple"/>ユーザー管理</div>
            </router-link>
            <router-link v-if="certificationFlag" :to="{name:getLinkTarget('CODealerSettingClientCertificate', 'CODealerSettingClientCertificate'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                 <div style="width:200px" :class='getClass("CODealerSettingClientCertificate")'><b-icon icon="certificate "/>クライアント証明書</div>
            </router-link>
        </template>
        <template v-else>
            <router-link :to="{name:getLinkTarget('COSettingHospital', 'COSettingHospital'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                <div :class='getClass("COSettingHospital")'><b-icon icon="hospital-building"/>施設管理</div>
            </router-link>
            <router-link :to="{name:getLinkTarget('COSettingUser', 'COSettingUser'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                <div :class='getClass("COSettingUser")'><b-icon icon="account-multiple"/>ユーザー管理</div>
            </router-link>
            <router-link :to="{name:getLinkTarget('COSettingRequestList', 'COSettingRequestList'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                 <div :class='getClass("COSettingRequestList")'><b-icon icon="format-list-bulleted "/>申請一覧</div>
            </router-link>
            <router-link v-if="certificationFlag"
             :to="{name:getLinkTarget('COSettingClientCertificate', 'COSettingClientCertificate'), params:{searchConditions:searchParam,careOrchestratorInstitutionId:careOrchestratorInstitutionId, certificationFlag:certificationFlag}}">
                 <div style="width:200px" :class='getClass("COSettingClientCertificate")'><b-icon icon="certificate "/>クライアント証明書</div>
            </router-link>
        </template>
    </div>
</template>

<script>
export default {
  name: "SettingNaviBar",
  props: ["pageid","data","searchConditions"],
  methods: {
    getLinkTarget: function(tabkind, target){
      var ret = target;
      if(tabkind == this.pageid){
        ret = ""
      }
      return ret;
    },
    getClass: function(tabkind) {
      var ret = "tabLabel ";
      if(tabkind == this.pageid){
        ret += "active";
      } else {
        ret += "deactive";
      }
      return ret;
    },
    isDealer: function(){
      if(this.pageid=="CODealerSettingHospital" || this.pageid == "CODealerSettingUser" || this.pageid == "CODealerSettingClientCertificate"){
        return true;
      }
      return false;
    },
  },
  data() {
    var searchParam = this.$route.params["searchConditions"];
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    return {
      searchParam: searchParam,
      certificationFlag: certificationFlag,
      careOrchestratorInstitutionId: careOrchestratorInstitutionId
    };
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 150px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/SettingNaviBar.vue